import React, { useEffect, useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import Alljobs from "./Alljobs";
import Gotop from "../../components/gotop";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import { useLocation } from "react-router-dom";
import axios from "../../API/axios";
import { Helmet } from "react-helmet";
import AlljobsNew from "./AllJobsNew";

const Searchjobs = () => {
  const [searchjobName, setSearchjobName] = useState("");
  const [selectedcompaniesId, setSelectedcompaniesId] = useState(null);
  const [cityId, setcityId] = useState(null);
  const [selectedJobTypeId, setSelectedJobTypeId] = useState(null);
  const [selectedworkLevelId, setSelectedworkLevelId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedDesignationId, setSelectedDesignationId] = useState(null);
  const [selectedSalaryTypeId, setSelectedSalaryTypeId] = useState(null);
  const [jobList, setjobList] = useState([]);
  const module = localStorage.getItem("Module");
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const [searchjobList, setSearchjobList] = useState([]);
  const [isShowMobile, setShowMobile] = useState(false);
  console.log('searchjobName', searchjobName);
 

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };


  return (
    <>
    
      {module === "Candidate" ? (
        <LoginMobileHeader handleMobile={handleMobile} />
      ) : module === "Institution" ? (
        <InstituteMobileHeader handleMobile={handleMobile} />
      ) : module === "Company" ? (
        <CRMobileHeader handleMobile={handleMobile} />
      ) : module === "Recruiter" ? (
        <CRMobileHeader handleMobile={handleMobile} />
      ) : (
        <MobileHeader handleMobile={handleMobile} />
      )}

      {module === "Candidate" ? (
        <LoginHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : module === "Institution" ? (
        <InstituteHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : module === "Company" ? (
        <CRHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : module === "Recruiter" ? (
        <CRHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : (
        <NonLoginHeader clname="searchjobheader" handleMobile={handleMobile} />
      )}

      <div className="pt-70">
        {/* <Alljobs
          className="jobs-section"
        // searchjobName={searchjobName}
        // setSearchjobName={setSearchjobName}
        // jobList={jobList}
        // searchjobList={searchjobList}
        // setjobList={setjobList}
        // cityId={cityId}
        // setcityId={setcityId}
        /> */}
        <AlljobsNew className="jobs-section"/>
        <Gotop />
      </div>
    </>
  );
};

export default Searchjobs;
